import React, {KeyboardEvent} from 'react';
import {OpenedLayerResult} from './layers';
import {createPortal} from 'react-dom';

export interface LayerPortalProps {
  readonly layerResult: OpenedLayerResult;
}

export function LayerPortal({layerResult}: LayerPortalProps): JSX.Element {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      layerResult.close();
    }
  };

  return createPortal(
    <div onKeyDown={handleKeyDown}>
      {layerResult.getLayerContent(layerResult.close)}
    </div>,
    layerResult.getMountPoint()
  );
}
